/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *
 *******************************************************************************/

 import React from 'react'
 import { connect } from 'react-redux'
 import PropTypes from 'prop-types'
 import { withStyles } from '@mui/styles'
import Contactus from '../../../components/Views/public/Contactus'
 
 const styles = theme => ({
   paper: {
       background: 'rgba(0, 0, 0, 0.5)',
   },
 })
 
 class ContactusPage extends React.Component {
   componentDidMount() {
     window.scrollTo(0, 0);
 
   }
   render() {
     return (
       <>
       <Contactus/>
       </>
     )
   }
 }
 
 ContactusPage.propTypes = {
   classes: PropTypes.object.isRequired,
 }
 
 function mapStateToProps() {
   return {}
 }
 
 const styledContactusPage = withStyles(styles)(ContactusPage)
 const connectedContactusPage = connect(mapStateToProps)(styledContactusPage)
 export { connectedContactusPage as ContactusPage }
 